import type { Delegacao } from '@/types/delegacao';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DelegacaoState {
  delegacoes: Delegacao[];
  isLoading: boolean;
  error: string | null;
}

const initialState: DelegacaoState = {
  delegacoes: [],
  isLoading: false,
  error: null,
};

const delegacaoSlice = createSlice({
  name: 'delegacao',
  initialState,
  reducers: {
    setDelegacaoLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setDelegacaoErro: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setDelegacoes: (state, action: PayloadAction<Delegacao[]>) => {
      state.delegacoes = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    addDelegacao: (state, action: PayloadAction<Delegacao>) => {
      state.delegacoes.push(action.payload);
      state.isLoading = false;
      state.error = null;
    },
    updateDelegacao: (state, action: PayloadAction<Delegacao>) => {
      const index = state.delegacoes.findIndex((d) => d.id === action.payload.id);
      if (index !== -1) {
        state.delegacoes[index] = action.payload;
      }
      state.isLoading = false;
      state.error = null;
    },
    removeDelegacao: (state, action: PayloadAction<string>) => {
      state.delegacoes = state.delegacoes.filter((d) => d.id !== action.payload);
      state.isLoading = false;
      state.error = null;
    },
    clearDelegacoes: (state) => {
      state.delegacoes = [];
      state.error = null;
    },
  },
});

export const { setDelegacoes, addDelegacao, updateDelegacao, removeDelegacao } =
  delegacaoSlice.actions;

export const delegacaoReducer = delegacaoSlice.reducer;
